interface ApiConfig {
    API: string;
}

interface S3Config {
  accessKey: string;
  secretKey: string;
  bucket: string;
  region: string;
  endpoint?: string;
}

interface Config {
  api: ApiConfig;
  s3: S3Config;
}

const config: Config = {
  api: {
    API: process.env.REACT_APP_API || "",
  },
  s3: {
    accessKey: process.env.REACT_APP_AWS_S3_ACCESS_KEY || "",
    secretKey: process.env.REACT_APP_AWS_S3_SECRET_KEY || "",
    bucket: process.env.REACT_APP_AWS_S3_BUCKET || "",
    region: process.env.REACT_APP_AWS_S3_REGION || "me-south-1",
    endpoint: process.env.REACT_APP_AWS_S3_ENDPOINT || "",
  },
};

export default config;
